<template>
    <div class="page font-p page-accessibility">
        <div class="page-wrap">
            <app-page-header></app-page-header>
            <app-page-body></app-page-body>
            <app-page-footer></app-page-footer>
        </div>
        <app-top-button></app-top-button>
        <app-header-stamp></app-header-stamp>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '@/components/assorted/PageHeader.vue';
import PageBody from '@/components/assorted/PageBody.vue';
import PageFooter from '@/components/assorted/PageFooter.vue';
import TopButton from '@/components/assorted/TopButton';
import HeaderStamp from '@/components/assorted/HeaderStamp';
import ScrollAnchor from '@/external/assorted/ScrollAnchor';
import Hotfixes from '@/external/assorted/Hotfixes';

export default {
    data() {
        return {};
    },
    components: {
        'app-page-header': PageHeader,
        'app-page-body': PageBody,
        'app-page-footer': PageFooter,
        'app-top-button': TopButton,
        'app-header-stamp': HeaderStamp
    },
    methods: {},
    computed: {
        ...mapGetters(['getCurrentRouteFullPath'])
    },
    mounted() {
        ScrollAnchor.bindActiveStates();
        Hotfixes.init();
    },
    watch: {
        getCurrentRouteFullPath() {
            this.$nextTick().then(() => {
                ScrollAnchor.resetActiveStates();
                ScrollAnchor.updateActiveStates();
                Hotfixes.init();
            });
        }
    },
    props: {}
};
</script>
